<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="520px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-tabs v-if="showUrl" v-model="activeTab">
      <el-tab-pane label="本地上传" name="upload">
        <div class="image-source-upload">
          <el-upload
            drag
            :headers="headers"
            :multiple="multiple"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :http-request="directUpload ? handleDirectUpload : undefined"
            accept="image/*"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将图片拖到这里，或<em>点击上传</em></div>
          </el-upload>
        </div>
      </el-tab-pane>
      <el-tab-pane label="图片URL" name="url">
        <el-input
          v-model="urlText"
          type="textarea"
          :rows="multiple ? 5 : 3"
          :placeholder="multiple ? '每行一个图片URL' : '粘贴图片URL'"
        ></el-input>
        <div class="url-tips">支持 http 或 https 图片地址。</div>
      </el-tab-pane>
    </el-tabs>
    <div v-else class="image-source-upload">
      <el-upload
        drag
        :headers="headers"
        :multiple="multiple"
        :show-file-list="false"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :http-request="directUpload ? handleDirectUpload : undefined"
        accept="image/*"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到这里，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <template #footer>
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" v-if="showUrl && activeTab === 'url'" @click="confirmUrl">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { uploadDirectOss } from '@/assets/js/utils/ossDirectUpload'

export default {
  name: 'ImageSourceDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '添加图片',
    },
    headers: {
      type: Object,
      default: () => ({}),
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    existingUrls: {
      type: Array,
      default: () => [],
    },
    showUrl: {
      type: Boolean,
      default: false,
    },
    directUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 'upload',
      urlText: '',
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.activeTab = 'upload'
        this.urlText = ''
      }
    },
  },
  methods: {
    getUploadImageUrl(res) {
      return res && res.code === 200 ? (res.data.address || res.data.url || res.data.storage_path || '') : ''
    },
    hasExistingUrl(url) {
      return this.existingUrls.includes(url)
    },
    handleUploadSuccess(res) {
      const url = this.getUploadImageUrl(res)
      if (!url) {
        this.$message.error(res.message || res.msg || '上传失败')
        return
      }
      if (this.hasExistingUrl(url)) {
        this.$message.warning('不能上传重复的图片')
        return
      }
      this.$emit('select', [url])
      this.$message.success('上传成功')
      this.handleClose()
    },
    handleUploadError(error) {
      this.$message.error(error && error.message ? error.message : '上传失败')
    },
    async handleDirectUpload(options) {
      try {
        const file = options.file
        if (!file || !file.type || !file.type.startsWith('image/')) {
          throw new Error('请选择图片文件')
        }
        const data = await uploadDirectOss(file, {
          purpose: 'merchant_image',
          headers: this.headers,
          onProgress: event => options.onProgress && options.onProgress(event),
        })
        const url = data.url
        if (this.hasExistingUrl(url)) {
          throw new Error('不能上传重复的图片')
        }
        options.onSuccess && options.onSuccess({ code: 200, data })
      } catch (error) {
        options.onError && options.onError(error)
      }
    },
    confirmUrl() {
      const urls = this.urlText
        .split(/\n|,|，/)
        .map(item => item.trim())
        .filter(Boolean)

      if (!urls.length) {
        this.$message.warning('请填写图片URL')
        return
      }
      const invalid = urls.find(url => !/^https?:\/\/.+/i.test(url))
      if (invalid) {
        this.$message.warning('图片URL仅支持http或https')
        return
      }
      const seen = new Set()
      const duplicate = urls.find(url => {
        if (this.hasExistingUrl(url) || seen.has(url)) return true
        seen.add(url)
        return false
      })
      if (duplicate) {
        this.$message.warning('不能上传重复的图片')
        return
      }

      this.$emit('select', this.multiple ? urls : [urls[0]])
      this.handleClose()
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped>
.image-source-upload {
  display: flex;
  justify-content: center;
}

.url-tips {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}
</style>
